<template>
  <div class="check-list-person auto-list_col_centered">
    <div v-if="responseAuto">
      <p class="date">{{ responseAuto }}</p>
      <p v-if="allowActive" class="date status" @click.stop="$emit('open')">
        Изменить авто
      </p>
    </div>
    <div v-else @click.stop="$emit('open')">
      <p v-if="allowActive" class="date status">Выбрать авто</p>
      <p v-else class="date">Нет данных</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StateNumbersInProgress',
  props: {
    responseAuto: {
      type: String,
      default: '',
    },
    allowActive: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style scoped>
.red {
  color: #f00;
}
</style>
